import React from 'react';
import './skeleton.css';

const makeItems = (count) => Array.from({ length: count }, (_, index) => index);

export const SkeletonBlock = ({ className = '' }) => (
  <span className={`skeleton-block ${className}`.trim()} aria-hidden="true" />
);

export const HomeVendorSkeletonCards = ({ count = 8 }) => (
  <>
    {makeItems(count).map((index) => (
      <div key={index} className="vendor-card skeleton-vendor-card" aria-hidden="true">
        <div className="vendor-card-media skeleton-vendor-media">
          <SkeletonBlock className="skeleton-vendor-cover" />
        </div>
        <div className="vendor-card-labels skeleton-vendor-labels">
          <SkeletonBlock className="skeleton-line skeleton-line-title" />
          <SkeletonBlock className="skeleton-line skeleton-line-subtitle" />
        </div>
      </div>
    ))}
  </>
);

export const HomeBannerSkeleton = () => (
  <div className="banner_slider banner-skeleton" aria-label="배너 로딩중">
    <div className="slider-image-wrapper banner-skeleton-frame">
      <SkeletonBlock className="banner-skeleton-media" />
      <div className="banner-skeleton-copy">
        <SkeletonBlock className="skeleton-line banner-skeleton-kicker" />
        <SkeletonBlock className="skeleton-line banner-skeleton-title" />
        <SkeletonBlock className="skeleton-line banner-skeleton-subtitle" />
      </div>
      <div className="banner-skeleton-dots">
        <SkeletonBlock className="banner-skeleton-dot banner-skeleton-dot-active" />
        <SkeletonBlock className="banner-skeleton-dot" />
        <SkeletonBlock className="banner-skeleton-dot" />
      </div>
    </div>
  </div>
);

export const MobileHomeSkeleton = () => (
  <div className="mobile-home-skeleton" aria-label="로딩중">
    <div className="mobile-home-skeleton-tabs">
      {makeItems(3).map((index) => (
        <div key={index} className="mobile-home-skeleton-tab">
          <SkeletonBlock className="mobile-home-skeleton-tab-icon" />
          <SkeletonBlock className="mobile-home-skeleton-tab-text" />
        </div>
      ))}
    </div>
    <div className="mobile-home-skeleton-feature">
      <SkeletonBlock className="skeleton-line skeleton-line-kicker" />
      <SkeletonBlock className="skeleton-line skeleton-line-feature" />
      <SkeletonBlock className="skeleton-pill" />
    </div>
    {[0, 1].map((section) => (
      <div key={section} className="mobile-home-skeleton-section">
        <div className="mobile-home-skeleton-section-head">
          <SkeletonBlock className="skeleton-circle" />
          <SkeletonBlock className="skeleton-line skeleton-line-heading" />
        </div>
        <div className="mobile-home-skeleton-grid">
          {makeItems(4).map((index) => (
            <div key={index} className="mobile-home-skeleton-card">
              <SkeletonBlock className="mobile-home-skeleton-card-icon" />
              <SkeletonBlock className="skeleton-line skeleton-line-game" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

export const SportsListSkeleton = ({ count = 5, mobile = false, variant = 'domestic' }) => {
  if (variant === 'international') {
    if (mobile) {
      return (
        <div className="sports-skeleton-native-list sports-skeleton-native-list-mobile" aria-label="경기 목록 로딩중">
          {makeItems(count).map((index) => (
            <div key={index} className="zi_m_card sports-skeleton-zi-mobile-card">
              <div className="zi_m_card_head">
                <div className="zi_m_card_league_wrap">
                  <SkeletonBlock className="sports-skeleton-flag" />
                  <SkeletonBlock className="sports-skeleton-ball" />
                  <SkeletonBlock className="skeleton-line sports-skeleton-mobile-league" />
                </div>
                <div className="zi_m_card_badges">
                  <SkeletonBlock className="skeleton-pill sports-skeleton-time" />
                </div>
              </div>
              <div className="zi_m_card_body">
                <div className="zi_m_card_teams">
                  <div className="zi_m_card_team">
                    <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                    <SkeletonBlock className="skeleton-line sports-skeleton-team" />
                  </div>
                  <div className="zi_m_card_team">
                    <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                    <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
                  </div>
                </div>
                <div className="zi_m_card_main">
                  <SkeletonBlock className="zi_m_list_odds sports-skeleton-odd" />
                  <SkeletonBlock className="zi_m_list_odds sports-skeleton-odd" />
                  <SkeletonBlock className="zi_m_list_odds sports-skeleton-odd" />
                  <SkeletonBlock className="zi_m_more_btn sports-skeleton-more" />
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    }

    return (
      <div className="sports-skeleton-native-list sports-skeleton-native-list-international" aria-label="경기 목록 로딩중">
        {makeItems(count).map((index) => (
          <div key={index} className="zi_card sports-skeleton-zi-card">
            <div className="zi_card_head">
              <SkeletonBlock className="sports-skeleton-flag" />
              <SkeletonBlock className="sports-skeleton-ball" />
              <SkeletonBlock className="skeleton-line sports-skeleton-league" />
              <SkeletonBlock className="skeleton-pill sports-skeleton-time" />
            </div>
            <div className="zi_card_body">
              <div className="zi_card_teams">
                <div className="zi_card_team">
                  <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                  <SkeletonBlock className="skeleton-line sports-skeleton-team" />
                </div>
                <div className="zi_card_team">
                  <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                  <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
                </div>
              </div>
              <div className="zi_card_odds">
                <SkeletonBlock className="zi_more_btn sports-skeleton-more" />
                <SkeletonBlock className="zi_odds_btn sports-skeleton-odd" />
                <SkeletonBlock className="zi_odds_btn sports-skeleton-odd" />
                <SkeletonBlock className="zi_odds_btn sports-skeleton-odd" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (mobile) {
    return (
      <div className="sports-skeleton-native-list sports-skeleton-native-list-mobile" aria-label="경기 목록 로딩중">
        {makeItems(count).map((index) => (
          <div key={index} className="zxsb_match_group zxsb_match_group_mobile sports-skeleton-domestic-mobile-card">
            <div className="zxsb_mobile_match_head">
              <div className="zxsb_mobile_match_teams">
                <span className="zxsb_mobile_match_team">
                  <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                  <SkeletonBlock className="skeleton-line sports-skeleton-team" />
                </span>
                <SkeletonBlock className="skeleton-line sports-skeleton-vs-line" />
                <span className="zxsb_mobile_match_team">
                  <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                  <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
                </span>
              </div>
              <SkeletonBlock className="skeleton-pill sports-skeleton-time" />
            </div>
            <div className="zxsb_m_market_rows">
              {makeItems(2).map((rowIndex) => (
                <div key={rowIndex} className="zxsb_m_market_row">
                  <SkeletonBlock className="zxsb_m_market_badge sports-skeleton-market-badge" />
                  <SkeletonBlock className="zxsb_m_market_name sports-skeleton-market-name" />
                  <div className="zxsb_m_market_cells zxsb_m_market_cells_3">
                    <SkeletonBlock className="zxsb_mo_btn sports-skeleton-odd" />
                    <SkeletonBlock className="zxsb_mo_btn sports-skeleton-odd" />
                    <SkeletonBlock className="zxsb_mo_btn sports-skeleton-odd" />
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="sports-skeleton-native-list sports-skeleton-native-list-domestic" aria-label="경기 목록 로딩중">
      {makeItems(count).map((index) => (
        <div key={index}>
          {index % 2 === 0 && (
            <div className="zxsb_league sports-skeleton-domestic-league">
              <SkeletonBlock className="sports-skeleton-flag" />
              <SkeletonBlock className="sports-skeleton-ball" />
              <SkeletonBlock className="skeleton-line sports-skeleton-league" />
            </div>
          )}
          <div className="zxsb_match_group sports-skeleton-domestic-group">
            <div className="zxsb_row">
              <div className="zxsb_row_badge">
                <SkeletonBlock className="zxsb_row_sport_icon sports-skeleton-ball" />
                <SkeletonBlock className="zxsb_row_result_badge sports-skeleton-result-badge" />
              </div>
              <div className="zxsb_row_meta zxsb_row_meta_home">
                <SkeletonBlock className="skeleton-line sports-skeleton-team" />
                <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
              </div>
              <SkeletonBlock className="zxsb_odds_btn sports-skeleton-odd" />
              <SkeletonBlock className="zxsb_odds_btn sports-skeleton-odd" />
              <SkeletonBlock className="zxsb_odds_btn sports-skeleton-odd" />
              <div className="zxsb_row_meta zxsb_row_meta_away">
                <SkeletonBlock className="skeleton-circle sports-skeleton-team-logo-small" />
                <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
              </div>
              <div className="zxsb_row_end">
                <SkeletonBlock className="skeleton-pill sports-skeleton-time" />
              </div>
            </div>
            <div className="zxsb_subrows">
              <div className="zxsb_subrow">
                <div className="zxsb_row_badge">
                  <SkeletonBlock className="zxsb_row_sport_icon sports-skeleton-ball" />
                  <SkeletonBlock className="zxsb_row_result_badge sports-skeleton-result-badge" />
                </div>
                <div />
                <SkeletonBlock className="zxsb_odds_btn sports-skeleton-odd" />
                <SkeletonBlock className="zxsb_subrow_line sports-skeleton-line-cell" />
                <SkeletonBlock className="zxsb_odds_btn sports-skeleton-odd" />
                <div />
                <div />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

/** Match list skeleton for InternationalPage & EsportsPage */
export const LspMatchListSkeleton = ({ count = 5 }) => (
  <div aria-hidden="true" style={{ pointerEvents: 'none' }}>
    {makeItems(count).map((i) => (
      <div key={i} className="lsp_match_group" style={{ marginBottom: 10 }}>
        <div className="lsp_league_header">
          <SkeletonBlock className="sk-light skeleton-block sk-lsp-flag" />
          <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-league" />
          <SkeletonBlock className="sk-light skeleton-block sk-lsp-badge" />
        </div>
        <div className="lsp_match_row" style={{ cursor: 'default' }}>
          <div className="lsp_teams_col">
            <div className="lsp_team_row">
              <SkeletonBlock className="sk-light skeleton-block sk-lsp-jersey" />
              <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-team" />
            </div>
            <div className="lsp_team_row" style={{ marginTop: 6 }}>
              <SkeletonBlock className="sk-light skeleton-block sk-lsp-jersey" />
              <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-team sk-lsp-team-short" />
            </div>
          </div>
          <div className="lsp_odds_cols">
            {makeItems(3).map((j) => (
              <div key={j} className="lsp_odds_col">
                <SkeletonBlock className="sk-light skeleton-block sk-lsp-odds" />
              </div>
            ))}
          </div>
        </div>
      </div>
    ))}
  </div>
);

/** Market detail skeleton for InternationalPage & EsportsPage detail panel */
export const LspMarketDetailSkeleton = ({ count = 5 }) => (
  <div aria-hidden="true" style={{ pointerEvents: 'none', padding: '4px 0' }}>
    {makeItems(count).map((i) => (
      <div key={i} className="lsp_mkt_section">
        <div className="lsp_mkt_section_header" style={{ background: '#f1f5f9' }}>
          <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-mkt-title" style={{ margin: 0 }} />
        </div>
        <div className="lsp_grid_row_3">
          {makeItems(3).map((k) => (
            <SkeletonBlock key={k} className="sk-light skeleton-block sk-lsp-grid-cell" />
          ))}
        </div>
        <div className="lsp_grid_row">
          {makeItems(2).map((k) => (
            <SkeletonBlock key={k} className="sk-light skeleton-block sk-lsp-grid-cell" />
          ))}
        </div>
      </div>
    ))}
  </div>
);

/** Match list skeleton for InplayPage */
export const IppMatchListSkeleton = ({ count = 4 }) => (
  <div aria-hidden="true" style={{ pointerEvents: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
    {makeItems(count).map((i) => (
      <div key={i} className="ipp_match_card">
        <div className="ipp_card_header">
          <div className="ipp_header_left">
            <SkeletonBlock className="sk-light skeleton-block sk-lsp-flag" />
            <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-league" />
          </div>
          <div className="ipp_header_right_info">
            <SkeletonBlock className="sk-light skeleton-block sk-ipp-time" />
          </div>
        </div>
        <div className="ipp_card_body">
          <div className="ipp_body_team_home">
            <SkeletonBlock className="sk-light skeleton-block sk-lsp-jersey" />
            <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-team" />
          </div>
          <div className="ipp_body_center_live" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4, minWidth: 70 }}>
            <SkeletonBlock className="sk-light skeleton-block sk-ipp-score" />
          </div>
          <div className="ipp_body_team_away" style={{ justifyContent: 'flex-end' }}>
            <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-lsp-team sk-lsp-team-short" />
            <SkeletonBlock className="sk-light skeleton-block sk-lsp-jersey" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

/** Market detail skeleton for InplayPage */
export const IppMarketDetailSkeleton = ({ count = 4 }) => (
  <div aria-hidden="true" style={{ pointerEvents: 'none', display: 'flex', flexDirection: 'column', gap: 16, padding: 5 }}>
    {makeItems(count).map((i) => (
      <div key={i} className="ipp_market_section">
        <div className="ipp_market_section_title" style={{ background: '#f1f5f9' }}>
          <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-ipp-mkt-title" />
        </div>
        <div className="ipp_market_section_content">
          {makeItems(2).map((j) => (
            <div key={j} className="ipp_market_row">
              <SkeletonBlock className="sk-light skeleton-block sk-ipp-odd" />
              <SkeletonBlock className="sk-light skeleton-block sk-ipp-odd" />
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);

/** Match list skeleton for DomesticPage */
export const DpMatchListSkeleton = ({ count = 4 }) => (
  <div aria-hidden="true" style={{ pointerEvents: 'none', display: 'flex', flexDirection: 'column', gap: 8 }}>
    {makeItems(count).map((i) => (
      <div key={i} className="dp_match_card">
        <div className="dp_card_header">
          <div className="dp_header_left">
            <SkeletonBlock className="sk-light skeleton-block sk-lsp-flag" />
            <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-dp-league" />
          </div>
          <div className="dp_header_right">
            <SkeletonBlock className="sk-light skeleton-block skeleton-line sk-dp-time" />
          </div>
        </div>
        <div className="dp_card_body_table">
          <div className="dp_card_odds_row">
            <SkeletonBlock className="sk-light skeleton-block sk-dp-cell" />
            <SkeletonBlock className="sk-light skeleton-block sk-dp-cell" style={{ maxWidth: 80 }} />
            <SkeletonBlock className="sk-light skeleton-block sk-dp-cell" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

/** Sidebar nav items skeleton for FigmaLeftRail */
export const NavItemsSkeleton = ({ count = 5 }) => (
  <div className="sk-nav-list" aria-hidden="true">
    {makeItems(count).map((i) => (
      <SkeletonBlock
        key={i}
        className="sk-light skeleton-block skeleton-line sk-nav-item"
        style={{ width: `${55 + (i % 3) * 15}%`, opacity: 1 - i * 0.08 }}
      />
    ))}
  </div>
);

export const SportsDetailSkeleton = ({ mobile = false }) => {
  if (mobile) {
    return (
      <div className="sports-skeleton-detail-native sports-skeleton-detail-mobile" aria-label="상세 로딩중">
        <div className="zi_m_detail_hero">
          <div className="zi_m_detail_team">
            <SkeletonBlock className="skeleton-circle zi_m_detail_logo sports-skeleton-team-logo" />
            <SkeletonBlock className="skeleton-line sports-skeleton-team" />
          </div>
          <SkeletonBlock className="skeleton-line sports-skeleton-vs" />
          <div className="zi_m_detail_team">
            <SkeletonBlock className="skeleton-circle zi_m_detail_logo sports-skeleton-team-logo" />
            <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
          </div>
        </div>
        <div className="zi_m_detail_markets">
          {makeItems(4).map((index) => (
            <div key={index} className="zi_m_detail_section sports-skeleton-market">
              <SkeletonBlock className="skeleton-line sports-skeleton-market-title" />
              <div className="zi_m_detail_grid">
                <SkeletonBlock className="zi_m_detail_btn sports-skeleton-odd" />
                <SkeletonBlock className="zi_m_detail_btn sports-skeleton-odd" />
                <SkeletonBlock className="zi_m_detail_btn sports-skeleton-odd" />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="sports-skeleton-detail-native" aria-label="상세 로딩중">
      <div className="zi_detail_head sports-skeleton-detail-head">
        <SkeletonBlock className="sports-skeleton-flag" />
        <SkeletonBlock className="sports-skeleton-ball" />
        <SkeletonBlock className="skeleton-line sports-skeleton-detail-title" />
        <SkeletonBlock className="skeleton-pill sports-skeleton-time" />
      </div>
      <div className="zi_detail_hero sports-skeleton-detail-hero">
        <div className="zi_detail_team">
          <SkeletonBlock className="skeleton-circle zi_detail_logo sports-skeleton-team-logo" />
          <SkeletonBlock className="skeleton-line sports-skeleton-team" />
        </div>
        <div className="zi_detail_score">
          <SkeletonBlock className="skeleton-line sports-skeleton-vs" />
        </div>
        <div className="zi_detail_team">
          <SkeletonBlock className="skeleton-circle zi_detail_logo sports-skeleton-team-logo" />
          <SkeletonBlock className="skeleton-line sports-skeleton-team sports-skeleton-team-short" />
        </div>
      </div>
      <div className="zi_detail_markets sports-skeleton-detail-markets">
        {makeItems(5).map((index) => (
          <div key={index} className="zi_mkt_section sports-skeleton-market">
            <SkeletonBlock className="skeleton-line sports-skeleton-market-title" />
            <div className="zi_mkt_grid">
              <SkeletonBlock className="zi_mkt_btn sports-skeleton-odd" />
              <SkeletonBlock className="zi_mkt_btn sports-skeleton-odd" />
              <SkeletonBlock className="zi_mkt_btn sports-skeleton-odd" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
